export const SMART_FORM_CONFIG: any = {
  cssClasses: {
    formContainer: '',
    actionButtons: 'btn',
    actionToolbar: 'action-toolbar-container',
    actionTitle: 'action-title'
  }
};
